var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j;
import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { BaseSingletonService, Singleton } from './service.base';
import { UIOpenService } from './service.ui';
import { SearchFieldService } from './servive.search.field';
import { EApiUrl } from '~/tools/api/types';
import { EFileSize, EFileType, EFilterType, FILE_WITH_COPYRIGHT_PREFIX, filterFileTypes, } from '~/shared/types';
import { ServiceFile } from '~/services/service.file';
import { ServicePaginator } from '~/services/service.paginator';
import { MobxQuery } from '~/tools/mobx.query';
import { api } from '~/tools/api';
import { TabsService } from '~/services/servive.tabs';
import { getFileExtension, getFileLink } from '~/tools/file';
import { ServiceConfig } from '~/services/service.config';
import { ServiceCommunity } from '~/services/service.community';
export let MediaSearchService = class MediaSearchService extends BaseSingletonService {
    searchFieldSvc;
    openDialogSvc;
    openSearchSvc;
    fileService;
    paginatorService;
    filterSvc;
    openFilterSvc;
    serviceConfig;
    communityService;
    itemsData = [];
    originalItemsData = [];
    tags = {};
    communityId;
    categoryId;
    order;
    query;
    filterType;
    originalFilters = {};
    subCategories = [];
    constructor(searchFieldSvc, openDialogSvc, openSearchSvc, fileService, paginatorService, filterSvc, openFilterSvc, serviceConfig, communityService) {
        super();
        this.searchFieldSvc = searchFieldSvc;
        this.openDialogSvc = openDialogSvc;
        this.openSearchSvc = openSearchSvc;
        this.fileService = fileService;
        this.paginatorService = paginatorService;
        this.filterSvc = filterSvc;
        this.openFilterSvc = openFilterSvc;
        this.serviceConfig = serviceConfig;
        this.communityService = communityService;
        makeObservable(this, {
            items: computed,
            lastItemId: computed,
            tags: observable,
            itemsData: observable,
            categoryId: observable,
            subCategories: observable,
            originalItemsData: observable,
            resetData: action,
            addSubCategory: action,
            clearSubCategories: action,
            setTags: action,
            setCategoryId: action,
            resetItems: action,
        });
        this.setCategoryId('0');
    }
    get items() {
        return this.itemsData;
    }
    set items(items) {
        this.itemsData = items;
    }
    get lastItemId() {
        return Number.parseInt(this.originalItemsData[this.originalItemsData.length - 1]?.id) || 0;
    }
    setOrder(order) {
        this.order = order;
    }
    handleClickBack = () => {
        if (!this.openSearchSvc.open) {
            this.openDialogSvc.handleClose();
        }
        if (this.openFilterSvc.open) {
            this.openFilterSvc.handleClose();
        }
        this.openSearchSvc.handleClose();
    };
    addSubCategory(subCategory) {
        this.subCategories.push(subCategory);
    }
    deleteSubCategory(previousSubCategoryId) {
        const previousSubCategoryPosition = this.subCategories.findIndex(subCategory => subCategory.breadCrumbId === previousSubCategoryId);
        if (previousSubCategoryPosition > -1) {
            this.subCategories.splice(previousSubCategoryPosition + 1);
        }
    }
    getCurrentSubCategory(currentSubCategoryId) {
        const previousSubCategoryPosition = this.subCategories.findIndex(subCategory => subCategory.breadCrumbId === currentSubCategoryId);
        if (previousSubCategoryPosition > -1) {
            this.subCategories.splice(previousSubCategoryPosition + 1);
        }
    }
    get lastSubCategoryIndex() {
        return this.subCategories.length - 1;
    }
    clearSubCategories() {
        this.subCategories = [];
    }
    get lastItem() {
        return this.items[this.items.length - 1];
    }
    setCategoryId(categoryId) {
        this.categoryId = categoryId;
    }
    setQuery(query) {
        this.query = query;
    }
    setTags(tags) {
        this.tags = { ...this.tags, [this.categoryId]: tags.join(',') };
    }
    setOriginalFilters(originalFilters) {
        this.originalFilters = { ...this.originalFilters, [this.categoryId]: originalFilters };
    }
    getItems(data) {
        return data?.map(item => ({
            img: this.fileService.getThumbnailLink(EFileSize.small, false, item),
            title: item.description,
            fileType: item.obj_type,
            extension: item.file_extension,
            id: item.id,
            depository: item.depository,
            name: item.name,
            date: item.date,
            eventLocation: item.location || '',
            author: item.author,
            physicalForm: item.physical_form_description,
            userId: item.user_id,
            physicalFormCode: item.physical_form_code,
            fileLink: getFileLink(`${item.obj_type === EFileType.image
                ? item.path + '_' + EFileSize.large + FILE_WITH_COPYRIGHT_PREFIX
                : item.path || ''}`, this.serviceConfig.awsUrl, getFileExtension(item.obj_type, item.file_extension), item.obj_type),
        }));
    }
    setFilterType(filterType) {
        this.filterType = filterType;
    }
    resetData() {
        this.paginatorService.resetPaginatorData();
        this.setQuery(undefined);
        this.setFilterType(EFilterType.all);
        this.filterSvc.handleChange(EFilterType.all);
        this.setCategoryId('0');
    }
    filterFiles(files) {
        if (!this.filterType || this.filterType === EFilterType.all) {
            return files;
        }
        return files.filter(file => filterFileTypes[this.filterType].includes(file.fileType));
    }
    resetItems() {
        this.originalItemsData = [];
        this.items = [];
    }
    getMediaItems(paginatorData, searchParams, tags) {
        const paginationParams = paginatorData ? paginatorData : this.paginatorService.paginatorData;
        return new MobxQuery({
            queryFn: (() => api
                .get(`${EApiUrl.communities}/${this.communityService.currentCommunity.id}/categories/${this.categoryId}/files`, {
                params: {
                    limit: paginationParams.limit,
                    offset: paginationParams.offset || 0,
                    order: this.order,
                    query: this.query,
                    searchParams,
                    types: this.filterType,
                    checkedTags: tags && tags[this.categoryId] ? tags[this.categoryId] : undefined,
                },
            })
                .then(response => {
                runInAction(() => {
                    const items = (paginationParams.offset || 0) > 0
                        ? [...this.items, ...(this.getItems(response.data?.collection) || [])]
                        : this.getItems(response.data?.collection) || [];
                    this.originalItemsData = items;
                    this.items = this.filterFiles(items);
                });
            })),
        }).query();
    }
};
MediaSearchService = __decorate([
    Singleton(),
    __metadata("design:paramtypes", [typeof (_a = typeof SearchFieldService !== "undefined" && SearchFieldService) === "function" ? _a : Object, typeof (_b = typeof UIOpenService !== "undefined" && UIOpenService) === "function" ? _b : Object, typeof (_c = typeof UIOpenService !== "undefined" && UIOpenService) === "function" ? _c : Object, typeof (_d = typeof ServiceFile !== "undefined" && ServiceFile) === "function" ? _d : Object, typeof (_e = typeof ServicePaginator !== "undefined" && ServicePaginator) === "function" ? _e : Object, typeof (_f = typeof TabsService !== "undefined" && TabsService) === "function" ? _f : Object, typeof (_g = typeof UIOpenService !== "undefined" && UIOpenService) === "function" ? _g : Object, typeof (_h = typeof ServiceConfig !== "undefined" && ServiceConfig) === "function" ? _h : Object, typeof (_j = typeof ServiceCommunity !== "undefined" && ServiceCommunity) === "function" ? _j : Object])
], MediaSearchService);
